/* -----------------------------------------------
              AUTH ACTION TYPES
-----------------------------------------------*/
export const LOGIN_ADMIN = 'LOGIN_ADMIN'
export const LOGIN_ADMIN_ERROR = 'LOGIN_ADMIN_ERROR'
export const LOAD_ADMIN_SUCCESS = 'LOAD_ADMIN_SUCCESS'
export const LOAD_ADMIN_ERROR = 'LOAD_ADMIN_ERROR'
export const LOADING_COMPLETE = 'LOADING_COMPLETE'
export const RESET_AUTH_ERRORS = 'RESET_AUTH_ERRORS'

export const LOGOUT_ADMIN = 'LOGOUT_ADMIN'

/* -----------------------------------------------
              CREATE BADGE TYPES
-----------------------------------------------*/
export const CREATE_BADGE_SUCCESS = 'CREATE_BADGE_SUCCESS'
export const CREATE_BADGE_ERROR = 'CREATE_BADGE_ERROR'

export const GET_BADGE_SUCCESS = 'GET_BADGE_SUCCESS'
export const GET_BADGE_ERROR = 'GET_BADGE_ERROR'

export const ISSUE_BADGE_SUCCESS = 'ISSUE_BADGE_SUCCESS'
export const ISSUE_BADGE_ERROR = 'ISSUE_BADGE_ERROR'

/* -----------------------------------------------
              USER TYPES
-----------------------------------------------*/
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_ERROR = 'GET_USER_ERROR'

export const GET_USER_BADGE_SUCCESS = 'GET_USER_BADGE_SUCCESS'
export const GET_USER_BADGE_ERROR = 'GET_USER_BADGE_ERROR'
